"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { markPopNavigation, recordRoute } from "@/lib/routeHistory";

/**
 * The only writer of `lib/routeHistory.ts`, mounted once in the root layout so
 * every client-side navigation is seen — including the ones between two pages
 * that never render this component's readers.
 *
 * `usePathname()` is the TRIGGER, `window.location.pathname` is the VALUE:
 * readers compare against a path they built themselves and should not have to
 * guess which of the two spellings (encoded or not) Next handed us. One source
 * for the string, and the router stays out of the components that only ask.
 */
export function RouteHistory() {
  const pathname = usePathname();

  useEffect(() => {
    recordRoute(window.location.pathname);
  }, [pathname]);

  /**
   * `popstate` fires before the router re-renders, so the flag is already set
   * when the page it lands on asks its question. A listener rather than a
   * comparison against a remembered path: only the event distinguishes "the
   * reader stepped back to a page they had open" from "the reader followed a
   * link to it again", and those two want opposite answers.
   */
  useEffect(() => {
    window.addEventListener("popstate", markPopNavigation);
    return () => window.removeEventListener("popstate", markPopNavigation);
  }, []);

  return null;
}
